import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
// import { exportTrackingSchema } from "../../../../redux/mappers/Export/";

export const exportTrackingApi = createApi({
  reducerPath: "exportTrackingApi",
  baseQuery,
  tagTypes: ["exportTracking"],

  endpoints: (builder) => ({
    // ✅ CREATE
    createExportTracking: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/mileStone/${id}`,
        method: "PUT",
        body: { milestone:data },
      }),
      invalidatesTags: ["exportTracking"],
    }),

    // ✅ UPDATE
    updateExportTracking: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/export/mileStone/${id}/${subId}`,
        method: "PUT",
        body: { milestone:data },
      }),
      invalidatesTags: ["exportTracking"],
    }),

    // ✅ GET
    getTrackingByExportMasterId: builder.query({
      query: ({ id }) => `/export/mileStone/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item, index) => ({
          ...item,
          SrNo: index + 1,
          id: item.exportMilestoneId, //  use backend's exportEntityId
        }));
      },
      providesTags: ["exportTracking"],
    }),
  }),
});

export const {
  useCreateExportTrackingMutation,
  useUpdateExportTrackingMutation,
  useLazyGetTrackingByExportMasterIdQuery,
} = exportTrackingApi;
